import { gql } from "@apollo/client";

export const getStoreGroupsSummary = gql`
  mutation GetStoreGroupsSummary(
    $limit: Int
    $offset: Int
    $status: KeywordGroupStatus
  ) {
    getStoreGroupsSummary(
      input: { sortBy: "name", status: $status }
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        name
        amountOfStores
        zipCodes
        status
      }
    }
  }
`;
